module.exports = __webpack_public_path__ + "static/media/1001221DO.fd47cbcb.jpg";